import { render, staticRenderFns } from "./CertificationTab.vue?vue&type=template&id=7f54f62f&scoped=true&"
import script from "./CertificationTab.vue?vue&type=script&lang=js&"
export * from "./CertificationTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f54f62f",
  null
  
)

export default component.exports